/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Day_Extra_Elephant_EmergeInputs */

const en_day_extra_elephant_emerge = /** @type {(inputs: Day_Extra_Elephant_EmergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show Comments`)
};

const de_day_extra_elephant_emerge = /** @type {(inputs: Day_Extra_Elephant_EmergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommentare anzeigen`)
};

/**
* | output |
* | --- |
* | "Show Comments" |
*
* @param {Day_Extra_Elephant_EmergeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const day_extra_elephant_emerge = /** @type {((inputs?: Day_Extra_Elephant_EmergeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Day_Extra_Elephant_EmergeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_day_extra_elephant_emerge(inputs)
	return de_day_extra_elephant_emerge(inputs)
});